import React from 'react'
import Scureimg from "../../../assets/images/secure.png"
import Abtimg from "../../../assets/images/abt_functional.png"
import Communication from "../../../assets/images/communication.png"
import Supportimg from "../../../assets/images/abt_support.png"
import Frameimg from "../../../assets/images/features_frame.png"
import PhonePreview from "../../../assets/images/nexa-policy-phone.png"
import PolicyArt from "../../../assets/images/capabilities/capability-1-crop.png"
import ClaimArt from "../../../assets/images/capabilities/capability-7-crop.png"
import SupportArt from "../../../assets/images/capabilities/capability-8-crop.png"
import GuideArt from "../../../assets/images/capabilities/capability-4-crop.png"
import FinancialArt from "../../../assets/images/capabilities/capability-5-crop.png"
import PersonalArt from "../../../assets/images/capabilities/capability-6-crop.png"
import ClaimBadge from "../../../assets/images/capabilities/capability-2-crop.png"
import SupportBadge from "../../../assets/images/capabilities/capability-3-crop.png"
import PaymentBadge from "../../../assets/images/capabilities/capability-9-crop.png"
import ProtectionBadge from "../../../assets/images/capabilities/capability-10-crop.png"
import HelpBadge from "../../../assets/images/capabilities/capability-11-crop.png"
import DocumentBadge from "../../../assets/images/capabilities/capability-12-crop.png"
import MascotPeekOpen from "../../../assets/images/mascot-peek-open.png"
import MascotPeekBlink from "../../../assets/images/mascot-peek-blink.png"

const capabilities = [
  { key: 'claims', title: 'Claims Assistance', description: 'Submit and track your claims in just a few taps. We’ll guide you every step of the way.', art: ClaimArt, badge: ClaimBadge },
  { key: 'support', title: '24/7 Support & Assistance', description: 'Our support team is always here for you, anytime, anywhere.', art: SupportArt, badge: SupportBadge },
  { key: 'guides', title: 'Safety Tips & Guides', description: 'Helpful tips and guides to keep you, your family, and your assets safe every day.', art: GuideArt, badge: DocumentBadge },
  { key: 'financial', title: 'Financial Protection', description: 'Build a stronger future with protection plans that help secure what matters most.', art: FinancialArt, badge: PaymentBadge },
  { key: 'personal', title: 'Personal Protection', description: 'Plans designed for you and your loved ones—because they deserve the best protection.', art: PersonalArt, badge: ProtectionBadge },
]

const CapabilityCard = ({ capability, large = false }) => (
  <article className={`capability-card capability-${capability.key} ${large ? 'capability-card-large' : ''}`}>
    <div className="capability-icon capability-image-icon" aria-hidden="true"><img src={capability.badge} alt="" /></div>
    <h3>{capability.title}</h3>
    <p>{capability.description}</p>
    <div className="capability-art" aria-hidden="true"><img src={capability.art} alt="" /></div>
    {capability.key === 'support' && (
      <div className="support-peek-mascot" aria-hidden="true">
        <img className="support-peek-frame support-peek-open" src={MascotPeekOpen} alt="" />
        <img className="support-peek-frame support-peek-blink" src={MascotPeekBlink} alt="" />
      </div>
    )}
  </article>
)

const Main = ({video}) => {
  if (video) {
    return (
      <section className="row_am features_section video-features" id="features">
        <div className="container">
          <div className="section_title"><h2><span>Features</span> that make the app different</h2></div>
          <div className="feature_detail">
            <div className="left_data feature_box">
              <div className="data_block"><div className="icon"><img src={Scureimg} alt="" /></div><div className="text"><h4>Secure data</h4><p>Your information stays private and protected.</p></div></div>
              <div className="data_block"><div className="icon"><img src={Abtimg} alt="" /></div><div className="text"><h4>Fully functional</h4><p>Everything you need in one simple app.</p></div></div>
            </div>
            <div className="right_data feature_box">
              <div className="data_block"><div className="icon"><img src={Communication} alt="" /></div><div className="text"><h4>Live chat</h4><p>Real help whenever you need it.</p></div></div>
              <div className="data_block"><div className="icon"><img src={Supportimg} alt="" /></div><div className="text"><h4>24/7 Support</h4><p>We’re always ready to assist.</p></div></div>
            </div>
            <div className="feature_img"><img src={Frameimg} alt="App feature preview" /></div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="row_am features_section exceptional-section" id="features">
      <div className="container">
        <div className="exceptional-grid">
          <div className="exceptional-left">
            <div className="exceptional-heading">
              <h2><span className="headline-primary">Protection made simple,</span><span className="headline-accent">wherever life <em>takes you.</em></span></h2>
              <p>Everything you need to stay protected, manage your policies, and get help <strong>all in one place.</strong></p>
            </div>
            <article className="policy-showcase" data-aos="fade-up">
              <div className="policy-copy">
                <div className="capability-icon capability-image-icon"><img src={PolicyArt} alt="" /></div>
                <h3>Policy<br />Management</h3>
                <strong>Your protection,<br />all in one place.</strong>
                <p>View your policies, track renewals, update details, and make payments securely and easily.</p>
              </div>
              <div className="phone-orbit" aria-hidden="true"></div>
              <img className="policy-phone" src={PhonePreview} alt="Nexa policy dashboard shown on a phone" />
            </article>
          </div>

          <div className="capabilities-right">
            <div className="capabilities-top">
              <CapabilityCard capability={capabilities[0]} large />
              <CapabilityCard capability={capabilities[1]} large />
            </div>
            <div className="capabilities-bottom">
              {capabilities.slice(2).map(capability => <CapabilityCard key={capability.key} capability={capability} />)}
            </div>
          </div>
        </div>

        <div className="protection-strip" data-aos="fade-up">
          <div className="priority-mark"><img src={PolicyArt} alt="" /></div>
          <div className="priority-copy"><h3>Your protection. Our priority.</h3><p>Simple to use. Easy to trust. Always here for you.</p></div>
          <div className="trust-point"><img src={HelpBadge} alt="" /><span><strong>Secure & Reliable</strong><small>Your data is protected with bank-level security.</small></span></div>
          <div className="trust-point orange"><img src={ClaimBadge} alt="" /><span><strong>Trusted by Many</strong><small>Thousands trust Nexa to protect what matters most.</small></span></div>
          <div className="trust-point"><img src={DocumentBadge} alt="" /><span><strong>Made for You</strong><small>Protection designed around real life.</small></span></div>
        </div>
      </div>
    </section>
  )
}

export default Main
